import { getFeatureFlag } from "@braze/web-sdk";

import { SEGMENT } from "../consts/consts";
import { SegmentType } from "../consts/interfaces";

export const getSegment = (tagId: string) => {
  const featureFlag = getFeatureFlag(tagId);
  if (featureFlag?.enabled) {
    return featureFlag.getStringProperty(SEGMENT.PROPERTY);
  }
  return null;
};

export const isValidSegmentType = (segment: string): segment is SegmentType =>
  [
    SEGMENT.SUST_MAVE,
    SEGMENT.ASP_SAVE,
    SEGMENT.CUSTOMERS,
    SEGMENT.OTHERS,
    SEGMENT.DEFAULT,
  ].includes(segment);
